import type { ChartUnit } from '../../../core/types/chart-unit.js';
import { getUnitAsString } from '../../../core/utils/get-unit-as-string.js';

// This function generates a unique ID for each Y-axis based on the unit of measurement.
// This is crucial for the XY chart adoption in the histogram, as it allows us to correctly associate each data series with its corresponding axis, especially when multiple units are involved.
export const defineAxisId = (unit: ChartUnit) =>
  `y-axis-${getUnitAsString(unit)}`;
